import Icon from '@mdi/react';
import { mdiPuzzle } from '@mdi/js';
import Android from "../Assets/Logos/Android_Logo.svg";
import Angular from "../Assets/Logos/Angular.svg"
import Ios from "../Assets/Logos/app-ios.svg";
import Css from "../Assets/Logos/Css.svg"
import C from "../Assets/Logos/C_Logo.svg";
import Cplus from "../Assets/Logos/Cplus.svg";
import Java from "../Assets/Logos/java.svg";
import JavaScript from "../Assets/Logos/JavaScript.svg";
import Html from "../Assets/Logos/Html5.svg"
import Laravel from "../Assets/Logos/Laravel.svg";
import MongoDB from "../Assets/Logos/Mongodb.svg"
import Mysql from  "../Assets/Logos/mysql.svg";
import NodeJs from "../Assets/Logos/NodeJs.svg";
import Php from "../Assets/Logos/PHP-Logo.svg";
import PostGre from "../Assets/Logos/Postgresql.svg";
import Python from "../Assets/Logos/Python.svg";
import ReactIcon from "../Assets/Logos/React.svg";
import Sqlite from "../Assets/Logos/Sqlite.svg";

import EnnaCafe from "../Assets/EnnaCafe.png";
import EstampaCharra from "../Assets/estampa-charra.jpg";
import HospitalSanJose from "../Assets/HospitalSanJose.png";
import MacsaId from "../Assets/Macsa.png";
import Sintramg from "../Assets/Sintramg.jpg";
import Cavii from "../Assets/cavii.png";



export const trustedCompanies = [
  { name: "Enna Cafe", logo: EnnaCafe},
  { name: "Estampa Charra", logo: EstampaCharra },
  { name: "Hospital San José de los Ojos", logo: HospitalSanJose },
  { name: "Macsa ID", logo: MacsaId},
  { name: "SINTRAMG", logo: Sintramg },
    { name: "CAVII", logo: Cavii },

];
export const logos = [
  Android,
  Ios,
  Html,
  Css,
  JavaScript,
  Angular,
  Laravel, 
  ReactIcon, 
  MongoDB,
  Mysql,
  PostGre,
  Sqlite,
  C,
  Cplus,
  Java,
  NodeJs,
  Php,
  Python,
];

export const navItems = [
    { label: "Inicio", href: "#" },
    { label: "Servicios", href: "#servicios" },
    { label: "Nosotros", href: "#nosotros" },
    // { label: "Portafolio", href: "#" },
    { label: "Contacto", href: "#contacto" },
  ];
  
  export const features = [
    {
      icon: <Icon path={mdiPuzzle} size={1} />,
      text: "Desarrollo Web",
      description:
        "Creamos sitios web modernos, rápidos y responsivos que representan tu marca y se adaptan a cualquier dispositivo. Desde landing pages hasta plataformas completas.",
    },
    {
      icon: <Icon path={mdiPuzzle} size={1} />,
      text: "Aplicaciones móviles",
      description:
        "Diseñamos y desarrollamos apps para iOS y Android, enfocadas en experiencia de usuario, funcionalidad fluida y escalabilidad.",
    },
    {
      icon: <Icon path={mdiPuzzle} size={1} />,
      text: "Software a medida",
      description:
        "¿Necesitas algo específico? Creamos sistemas hechos desde cero para cubrir necesidades únicas de tu negocio, desde paneles de control hasta soluciones internas.",
    },
    {      
      icon: <Icon path={mdiPuzzle} size={1} />,
      text: "Automatización de procesos",
      description:
        "Eliminamos tareas repetitivas con herramientas personalizadas que automatizan tus flujos de trabajo y mejoran tu productividad.",
    },
    {
      icon: <Icon path={mdiPuzzle} size={1} />,
      text: "Base de Datos",
      description:
        "Diseñamos e implementamos bases de datos eficientes, seguras y escalables que centralizan tu información y permiten que tus sistemas funcionen de forma ordenada, rápida y confiable.",
    },
  ];
  